<template>
  <v-timeline
    align-top
    :dense="$vuetify.breakpoint.smAndDown"
  >
    <v-timeline-item
      v-for="(item, i) in items"
      :key="i"
      :color="item.color"
      :icon="item.icon"
      fill-dot
    >
      <v-card
        :color="item.color"
        dark
      >
        <v-card-title class="text-h6">
          {{ item.title }}
        </v-card-title>

        <v-card-subtitle>
          {{ item.year }}
        </v-card-subtitle>

        <v-card-text class="white text--primary pt-4">
          <p>{{ item.content }}</p>

          <v-btn
            v-if="item.buttonText"
            :color="item.color"
            class="mx-0"
            outlined
            :href="item.buttonURL"
            target="_blank"
          >
            {{ item.buttonText }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-timeline-item>
  </v-timeline>
</template>


<script>
  export default {
    name: "ProspiraTimeline",
    data: () => ({
      items: [
        {
          title: 'Bridgestone APM Established',
          year: '1987',
          content: `Bridgestone APM established as a joint venture 
          (Clevite-Bridgestone company) owned by Clevite Elastomers
           of Milan, Ohio and Bridgestone Corporation of Tokyo Japan.`,
          buttonText: '',
          buttonURL: '',
          color: '#212121',
          icon: 'mdi-star',
        },
        {
          title: 'Bridgestone APM Begins Manufacturing',
          year: '1988',
          content: "Bridgestone APM's manufacturing operations begin at the Clevite Elastomers plant in Angola, Indiana.  Originally, there were three injection presses and three thousand square feet of workspace.",
          buttonText: '',
          buttonURL: '',
          color: '#00B1C3',
          icon: 'mdi-archive-cog',
        },
        {
          title: 'Expansion to Findlay Ohio',
          year: '1991',
          content: "The Findlay, Ohio facility is established and manufacturing operations are moved to Findlay.",
          buttonText: '',
          buttonURL: '',
          color: '#212121',
          icon: 'mdi-arrow-expand-vertical',
        },
        {
          title: 'Bridgestone APM Becomes Wholly-owned Subsidiary',
          year: '1993',
          content: "Bridgestone Corporation of Japan purchased all shares of the joint venture, establishing BAPM as a wholly-owned subsidiary.",
          buttonText: '',
          buttonURL: '',
          color: '#00B1C3',
          icon: 'mdi-merge',
        },
        {
          title: 'BAPM Expands Operations',
          year: '1996',
          content: "BAPM Expands its operations to a second location in Upper Sandusky, Ohio producing similar products as well as performing metal coating operations.",
          buttonText: '',
          buttonURL: '',
          color: '#212121',
          icon: 'mdi-arrow-expand-all',
        },
        {
          title: 'Consolidation of All Anti-Vibration Division Operations',
          year: '2010',
          content: "BAPM Consolidates all Anti-Vibration Division Operations and establishes a new headquarters office building in Findlay, Ohio.",
          buttonText: '',
          buttonURL: '',
          color: '#00B1C3',
          icon: 'mdi-consolidate',
        },
        {
          title: 'Acquired by Zhong Ding Incorporated',
          year: '2022',
          content: "BAPM Anti-Vibration Division is acquired by Zhong Ding Incorporated and our name is changed to Prospira America Corporation.",
          buttonText: 'Global Site',
          buttonURL: 'https://prospira.com/',
          color: '#212121',
          icon: 'mdi-star',
        },
      ],
    }),
  }
</script>